<span class="badge badge-{{size}} badge-{{type}} {{light}} badge-{{color}} {{class}}">{{ text }}</span>
